import { VLayout } from '@/shared/ui/layouts/flex'
import { VendomeLayout } from '@/shared/ui/layouts/vendome'
import { Loader } from '@/shared/ui/loader'
import { Typography } from '@/shared/ui/typography'

import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Loading - Full-screen application loading state, built with Design System components.
 *
 * Displayed while the application boots (before a session exists, while the user info and the
 * translation catalog are being fetched) and as the router hydrate fallback. It carries no data,
 * no state and no user action.
 *
 * Design System migration of the legacy loading view (since removed).
 */
export const Loading: FC = () => {
  const { t } = useTranslation()

  return (
    <VendomeLayout>
      <VLayout items="center" justify="center">
        {/*
         * `propagate` is passed explicitly on purpose. The Typography JSDoc and the Design System
         * usage sheet both document `@default false`, while the implementation currently defaults
         * to `true`. The white ring and white label on the dark Vendome background rely on this
         * propagation, so the behaviour must never depend on that contested default.
         *
         * How it works: `.typography-propagate *` forces `color: inherit !important` on every
         * descendant. `.loading` paints the spinner with `background-color: currentColor`, so both
         * the ring and the label inherit `base-100` — matching the legacy screen exactly.
         */}
        <Typography as="div" type="paragraph" variant="lg" color="base-100" propagate>
          <Loader size="lg" label={t('common.loading.app')} />
        </Typography>
      </VLayout>
    </VendomeLayout>
  )
}
